import { render } from "./Exporting.vue?vue&type=template&id=2bd3acec&scoped=true"
import script from "./Exporting.vue?vue&type=script&lang=js"
export * from "./Exporting.vue?vue&type=script&lang=js"

import "./Exporting.vue?vue&type=style&index=0&id=2bd3acec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd3acec"]])

export default __exports__